import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-572ea964"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "expertWrapper layout p-b20 border-box" };
const _hoisted_2 = { class: "expertInfo" };
const _hoisted_3 = { class: "expertImg m-auto border-box" };
const _hoisted_4 = { class: "box" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "info font-28 p-lr32 border-box" };
const _hoisted_7 = { class: "expertName font-44 m-auto text-overflow" };
const _hoisted_8 = { class: "hospital gray-9 text-overflow m-auto" };
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { class: "listTitle p-lr32 m-t20 flexBox" };
const _hoisted_12 = { class: "type" };
const _hoisted_13 = { class: "font-36" };
const _hoisted_14 = { class: "font-28 gray-6" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "listBox p-lr20 p-tb24 border-box white-bg m-auto" };
import { appPort, appFullScreen, getUserId, jumpModuleApp, mathRound, weixinShare } from '@/widget';
import { ref, nextTick, onMounted, onUnmounted, computed } from 'vue';
import CourseList from '@/components/list/CourseList.vue';
import { getExpertInfo, getExpertCourse } from '@/api/es';
import { getDepId } from '@/api/user';
import { useRoute, useRouter } from 'vue-router';
import { hostPath } from '@/public/utils/basePath';
import AppShare from '@/components/common/AppShare.vue';
import { useAppPageBar } from '@/hooks/appPage';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { barH, pxToRem, rem } = useAppPageBar();
        const color = ref('white');
        const router = useRouter();
        const route = useRoute();
        const showBl = ref(false);
        const showMore = () => {
            showBl.value = true;
        };
        const isApp = appPort();
        if (appPort()) {
            appFullScreen();
        }
        const expertId = Number(route.params.id);
        const expertInfo = ref({});
        const userId = getUserId();
        let departmentId = 1;
        const getData = async () => {
            await getDepId(userId).then((res) => {
                if (res.code == 200) {
                    departmentId = res.data.depId;
                }
            });
            await getExpertInfo({
                departmentId,
                expertId
            }).then((res) => {
                if (res.code == 200) {
                    expertInfo.value = res.data || {};
                    document.title = '好医术-' + expertInfo.value.expertName || '';
                    departmentId = expertInfo.value.departmentId;
                    nextTick(() => {
                        const dom = document.querySelector('.expertDesc');
                        const dom1 = document.querySelector('.expertMsg');
                        if (dom && dom1) {
                            showBl.value = dom1.offsetHeight >= dom.offsetHeight;
                        }
                    });
                    if (!appPort()) {
                        weixinShare({
                            title: expertInfo.value.expertName,
                            desc: expertInfo.value.hospitalName,
                            url: location.href,
                            image: expertInfo.value.cover
                        });
                    }
                }
            });
            await getList(0);
            await getList(1);
            await getList(2);
        };
        const list = ref([]);
        const typeList = [
            {
                type: 'OPEN',
                typeName: '公开课'
            },
            {
                type: 'MASTER',
                typeName: '大师课'
            },
            {
                type: 'OMO',
                typeName: 'OMO训练营'
            },
        ];
        let data = {
            page: 1,
            expertId,
            departmentId,
            stepType: 'STEP2',
            navigationType: 'OPEN'
        };
        const getList = (n) => {
            data.departmentId = departmentId;
            return new Promise(resolve => {
                var val = typeList[n];
                if (!val) {
                    resolve(true);
                    return;
                }
                data.navigationType = val.type;
                getExpertCourse(data).then((res) => {
                    if (res.code == 200) {
                        resolve(true);
                        list.value.push({
                            type: val.type,
                            typeName: val.typeName,
                            total: res.data.total,
                            list: res.data.items
                        });
                    }
                });
            });
        };
        getData();
        const watchMore = (type) => {
            let url = `/expert/${type.toLowerCase()}/${expertId}`;
            if (appPort()) {
                jumpModuleApp({
                    typeId: 'h5',
                    url: `${hostPath}/learn${url}`
                });
            }
            else {
                location.href = `${hostPath}/learn${url}`;
                //router.push(url)
            }
        };
        // 监听滚动
        const scrollY = ref(0);
        const domH = (102 / 100) * rem;
        const domStyle = ref({});
        const scrollFn = () => {
            scrollY.value = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollY.value > domH) {
                color.value = 'black';
                domStyle.value = { background: '#f5f5f7' };
            }
            else {
                color.value = 'white';
                domStyle.value = {};
            }
        };
        // 计算透明度
        const domOpacity = computed(() => {
            return scrollY.value < domH ? mathRound(scrollY.value / domH, 1) : 1;
        });
        onMounted(() => {
            if (isApp) {
                window.addEventListener('scroll', scrollFn, false);
            }
        });
        onUnmounted(() => {
            if (isApp) {
                window.removeEventListener('scroll', scrollFn, false);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(isApp))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "appStatusBar",
                        style: _normalizeStyle({
                            opacity: _unref(domOpacity)
                        })
                    }, [
                        _createElementVNode("div", {
                            style: _normalizeStyle({ height: _unref(pxToRem)(326 + _unref(barH)) + 'rem' })
                        }, null, 4)
                    ], 4))
                    : _createCommentVNode("", true),
                (_unref(isApp))
                    ? (_openBlock(), _createBlock(AppShare, {
                        key: 1,
                        color: color.value,
                        shareInfo: {
                            desc: expertInfo.value.hospitalName,
                            image: expertInfo.value.cover,
                            title: expertInfo.value.expertName
                        },
                        domStyle: domStyle.value
                    }, null, 8, ["color", "shareInfo", "domStyle"]))
                    : _createCommentVNode("", true),
                _createElementVNode("dl", _hoisted_2, [
                    _createElementVNode("dt", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("img", {
                                src: expertInfo.value.cover,
                                alt: ""
                            }, null, 8, _hoisted_5)
                        ])
                    ]),
                    _createElementVNode("dd", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(expertInfo.value.expertName), 1),
                        _createElementVNode("div", _hoisted_8, " - " + _toDisplayString(expertInfo.value.hospitalName) + " - ", 1),
                        _createElementVNode("div", {
                            class: _normalizeClass(["expertMsg gray-6", { 'text-ell2': !showBl.value }])
                        }, [
                            _createElementVNode("span", {
                                class: "expertDesc",
                                innerHTML: expertInfo.value.description?.replace(/(\r\n|\r|\n)/g, '<br /><br />')
                            }, null, 8, _hoisted_9)
                        ], 2),
                        (!showBl.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "showMore font-w500",
                                onClick: _withModifiers(showMore, ["stop"])
                            }, " 展开 ", 8, _hoisted_10))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                        (item.list.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("b", _hoisted_13, _toDisplayString(item.typeName), 1),
                                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.total), 1)
                                    ]),
                                    (item.total > 2)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "moreBtn font-28 gray-9",
                                            onClick: _withModifiers(($event) => (watchMore(item.type)), ["stop"])
                                        }, " 查看更多 ", 8, _hoisted_15))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                    _createVNode(CourseList, {
                                        list: item.list
                                    }, null, 8, ["list"])
                                ])
                            ], 64))
                            : _createCommentVNode("", true)
                    ]));
                }), 256))
            ]));
        };
    }
});
